import { ErrorReporter, ErrorReportDetailsType } from '@xlearn/async-toolbox'
import * as Sentry from '@sentry/vue'

export const errorReporter = new ErrorReporter(({error, extra}) => {
  Sentry.captureException(error, {
    extra: { details: extra }
  })
})

export function reportFatalError(message: string, ...details: ErrorReportDetailsType[]) {
  errorReporter.sendFatalError(message, ...details)
}

export function reportNonFatalError(message: string, ...details: ErrorReportDetailsType[]) {
  errorReporter.sendNonFatalError(message, ...details)
}

export const reportAnomaly = reportNonFatalError
